export function hasInterpolation(value: any) {
  return typeof value === 'string' && value.includes('<ppl-tag');
}
